import ServiceBase from "base/baseService"
import { boolToNumber } from "helper/formater"
import { jsDateToLuxonString } from "helper/formater"

export default class RegimeTributacaoService extends ServiceBase {

    title = "Regime de tributação"
    pluralTitle = "Regime de tributações"
    url = '/cadastro/fiscal/regimetributacao'
    frontUrl = '/cadastro/fiscal/regimetributacao'
    frontUrlList = '/cadastro/fiscal/regimetributacaolist'
    primaryKey = 'codigo_regit'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        data.direito_cred_regit = boolToNumber(data.direito_cred_regit)
        data.especial_regit = boolToNumber(data.especial_regit)

        return data
    }

    prepareToSave({ data }) {

        data.dh_atua_regit = jsDateToLuxonString(data.dh_atua_regit)

        data.direito_cred_regit = boolToNumber(data.direito_cred_regit)
        data.especial_regit = boolToNumber(data.especial_regit)

        delete data.meta

        return data

    }

}
